// extracted by mini-css-extract-plugin
export default {"Table":"styles_Table__BJYjS","middle":"styles_middle__OmOZ6","Wrapper":"styles_Wrapper__vE-tt","Caption":"styles_Caption__ZRljB","PDFBtn":"styles_PDFBtn__KXoFN"};